import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
/**
 * global configuration for NgbModal Bootstrap
 */
export const DIALOG_MEDIUM_CONFIG: NgbModalOptions = {
	size: 'md',
	scrollable: true,
	centered: true
};

export const DIALOG_LARGE_CONFIG: NgbModalOptions = {
	size: 'lg',
	scrollable: true,
	centered: true
};

export const ERROR_MESSAGES = {
	0: "Errore generico, contattare l'amministratore del sistema",
	401: 'Utente non autorizzato',
	403: "Non è permesso chiamare le API. Contattare l'amministratore del sistema",
	404: "Problema nella chiamata al server. Contattare l'amministratore del sistema"
};
